<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">News Feed</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="text-center">
        <p>
          365.stream introduces new way to trade cryptocurrencies.
        </p>
      </div>

      <div class="panel panel-filled">
        <div class="panel-body">
          <div data-example-id="horizontal-dl" v-if="ready">
            <dl class="dl-horizontal">
              <div v-for="n in this.newsfeed" v-bind:key="n.id">
                <dt>{{ n.pubDate }}</dt>
                <dd>
                  <a v-bind:href="n.guid" target="_blink">{{ n.title }}</a>
                </dd>
              </div>
            </dl>
          </div>
          <div class="loader-example" v-else>
            <div class="loader-bar"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return { newsfeed: null, ready: false };
  },
  methods: {
    news() {
      axios
        .get(
          "https://api.rss2json.com/v1/api.json?rss_url=http://medium.com/feed/@365.stream"
        )
        .then(res => {
          this.newsfeed = [];
          res.data.items.forEach(n => {
            n.pubDate = moment(n.pubDate).format("Y-MM-DD");
            this.newsfeed.push(n);
          });
          this.ready = true;
        })
        .catch(error => console.log(error));
    }
  },
  created() {
    this.news();
  }
};
</script>
